import { Banner, ButtonText } from '@morressier/alembic';
import { IBannerProps } from '..';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/pro-regular-svg-icons';
import { EditorialRevisionContextModal } from '../../modals/editorial/RevisonContext';
import { useState } from 'react';
import { timeFormatDeadlineDate } from '../../../../utils/date';

export const EditorialRevisionBanner = ({
  submissionId,
  workflowData,
  copyVariant = 'submission'
}: IBannerProps & { copyVariant?: 'submission' | 'reviews' }) => {
  const deadline = workflowData.currentDeadline;
  const [showModal, setShowModal] = useState(false);

  let content = `The author was invited to revise this submission until ${timeFormatDeadlineDate(
    deadline!
  )}.`;
  if (copyVariant === 'submission') {
    content +=
      ' Updates to the submission are locked until the revision is finished.';
  }

  if (copyVariant === 'reviews') {
    content +=
      ' Updates to the submission and review functionalities are locked until the revision is finished. Meanwhile, you can revisit past reviews to track progress.';
  }

  return (
    <>
      <Banner
        variant="attention"
        customIcon={<FontAwesomeIcon icon={faWarning} />}
        heading="Under Author Revision"
        content={content}
        action={
          <ButtonText onClick={() => setShowModal(true)}>
            View Details
          </ButtonText>
        }
      />

      {showModal && (
        <EditorialRevisionContextModal
          submissionId={submissionId}
          onClose={() => setShowModal(false)}
          deadline={deadline}
          role="editorial"
        />
      )}
    </>
  );
};
